import React from 'react'
import { isArray } from 'lodash'
import petrovich from 'petrovich'
import { FormattedMessage } from 'react-intl'

//import Share from '../Sidebar/Share'
//import SidebarImage from '../Sidebar/Image'
import SidebarFooter from '../Sidebar/Footer'
import IsMobile from '../../containers/Main/IsMobileHoc'
import Swiper from 'react-id-swiper'

const getFistName = (name, gender = 'male') => petrovich({ gender, first: name.split(' ')[0] }, 'genitive').first

const LotSidebar = ({ data, person, image, imageToPreview, isMobile, meta = {} }) => {
  if (person && !isArray(person)) person = [ person ]
  if (!person) person = [ data ]
  console.log(data);
  var menu = data.photos
  let params = {}
  if (data.photos.length > 1 /*&& data.projectId == "600aaa9c80d1eb09402879e3"*/) {
      params = {
      grabCursor: true,//true
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: false,
      autoplay: {delay: 3000, disableOnInteraction: false},
      watchOverflow: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
          renderBullet: function (index, className) {
            //return '<span class="' + className + '">' + (menu[index]) + '</span>';
            return '<img class="'+ className +'" src="'+(menu[index])+'" width="150px" height="120px"/>';
          },
      },
      
    }
  } else {
      params = {
      grabCursor: true,//true
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: false,
      watchOverflow: true,
    }
  }
  return !data.name ? null : (
    <div>
      <div className='Sidebar__bg'>
      <Swiper {...params} >
          {/* <SidebarImage name={data.name} image={image} /> */}
          {/* Ниженаписанный код специально для слайдера в лоте */}
          {/* Если не передан imageToPreview значит отображаем со слайдером изображения, иначе отображаем без слайдера изображения */}
          {!imageToPreview 
          ?
           data.photos.map((photo, index) =>
            (
              <div key={index}>
                <img className='Sidebar__bg-img' src={photo} alt='img'/>
                <div className='Sidebar__bg-overlay'/>
              </div>
            ))
          : 
            <div>
              <img className='Sidebar__bg-img' src={imageToPreview} alt='img'/>
              <div className='Sidebar__bg-overlay'/>
            </div>
          }
      </Swiper>
      </div>
      {/*<Share isMobile={isMobile} meta={meta} isAbsolute />*/}

      <SidebarFooter
        className='Sidebar__footer_person'
        Left={
          <div>
            <h1 className='Head Sidebar__head'>
              {data.name}
              {/* {data.name.split(' ').map((part, i) => <div key={i}>{part}</div>)} */}
            </h1>

            {person.map(el => {
              if (!el.facebookPage) return null
              return (
                <div className='Sidebar__profile' key={el._id}>
                  <div key={`fb-${el._id}`}>
                    <a className='Link Link_light' href={el.facebookPage}>
                      <FormattedMessage id='lot_sidebar.profile' />
                      {' '}{getFistName(el.name, el.gender)}{' '}
                      <FormattedMessage id='lot_sidebar.on_facebook' />
                    </a>
                  </div>
                </div>
              )
            })}
          </div>
        }
      />
    </div>
  )
}

export default IsMobile(LotSidebar)



// WEBPACK FOOTER //
// ./src/components/Lot/Sidebar.jsx